<template>
  <div class="home">
    <div class="grid">
      <h1> Borja Zarco Cerezo</h1>
    </div>
    <router-link class="contact-button" to="/contactme"><span>Contact Me!</span></router-link>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* background-image: url(https://picsum.photos/2560/1470/?image=1069); */
}

h1 {
  font-size: 100px;
  color: black;
}

.contact-button {
  border-radius: 2px;
  background: none;
  border: 1px solid black;
  color: black;
  text-align: center;
  transition: all 0.5s;
  padding: 10px 20px;
  transition-duration: 200ms;
}

.contact-button span {
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.contact-button span:after {
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
}

.contact-button:hover span {
  padding-right: 25px;
}

.contact-button:hover span:after {
  opacity: 1;
  right: 0;
}

.contact-button:hover {
  background-color: #fff;
  color: black;
  transition-duration: 200ms;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue